module.exports = __webpack_public_path__ + "img/home2.b3b892c5.svg";